import React from 'react'

import { ButtonProps } from '../../Button'
import { SetStepCursor, StepCursor } from '../../FullScreenStepper/FullScreenStepperProps'

export const augmentButtonProps = (
  internalProps: { onClick?: () => Promise<void> },
  externalProps: ButtonProps = {},
  setStepCursor: SetStepCursor,
  stepCursor: StepCursor,
  incrementor: number,
): ButtonProps => {
  const mergedProps = { ...internalProps, ...externalProps }
  mergedProps.onClick = async () => {
    if (typeof externalProps.onClick === 'function') {
      await externalProps.onClick({} as React.MouseEvent<HTMLButtonElement, MouseEvent>)
      setStepCursor(stepCursor + incrementor)
    } else if (typeof internalProps.onClick === 'function') {
      internalProps.onClick()
    }
  }
  return mergedProps
}
